import { useMutation, useQuery } from '@tanstack/react-query';
import { createCoverageConfig, deleteCoverageConfig, getAvailableCoverages, getCoverageConfigs, updateCoverageConfig } from '@/features/quotations/services/coverageConfigService';

const BASE = 'coverage-configs';

export const coverageConfigQueryKeys = {
  base: () => [BASE],
  list: (data) => (data ? [BASE, 'list', data] : [BASE, 'list']),
  availableCoverages: () => [BASE, 'available-coverages'],
};

export const useGetCoverageConfigs = (data, { enabled = true } = {}) => {
  return useQuery({
    queryKey: coverageConfigQueryKeys.list(data),
    queryFn: () => getCoverageConfigs(data),
    enabled: enabled,
  });
};

export const useGetAvailableCoverages = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: coverageConfigQueryKeys.availableCoverages(),
    queryFn: getAvailableCoverages,
    enabled,
  });
};

export const useCreateCoverageConfig = () => {
  return useMutation({
    mutationFn: (data) => createCoverageConfig(data),
  });
};

export const useUpdateCoverageConfig = () => {
  return useMutation({
    mutationFn: ({ id, data }) => updateCoverageConfig(id, data),
  });
};

export const useDeleteCoverageConfig = () => {
  return useMutation({
    mutationFn: ({ id }) => deleteCoverageConfig(id),
  });
};
